"use strict";

let dmSwitch = document.querySelector(".switch-theme");

var activeTheme = localStorage.getItem("theme");


dmSwitch.addEventListener("click", changeTheme);

// si theme est dans local storage:
if(activeTheme){
	// l' attribut data-theme est injecté dans l' élément body avec la valeur de localStorage
	document.body.setAttribute("data-theme", activeTheme);
}

function changeTheme(event){
	event.preventDefault();
	// ajoute si il n' existe pas ou modifie la class theme-trigger--dark
	var activeTheme = document.body.getAttribute("data-theme");
	// si activeTheme est différent de "dark"
	if(activeTheme != "dark"){
		// ajoute l' attribut data-theme avec la valeur dark dans le body
		document.body.setAttribute("data-theme", "dark");
		//ajoute le theme dark au local storage
		localStorage.setItem("theme", "dark");
	}else{
		// ajoute l' attribut data-theme avec la valeur light dans le body
		document.body.setAttribute("data-theme", "light");
		//ajoute le theme light au local storage
			localStorage.setItem("theme", "light");
	}
}





//anim bubbles desktop

function animBubbles(){

  const tlDesktop = gsap.timeline( {defaults: {y: -1200, duration: 2.5, ease: "power2.in", repeat: -1}});

  tlDesktop.fromTo(
    "#bubble1",
    {y: 55},
    { duration: 3},
    )
    .fromTo(
    "#bubble2",
    {x: 55, y: 55},
    { },
    0.75
    )
    .fromTo(
    "#bubble3",
    {y: 55},
    { },
    1.1
    )
    .fromTo(
    "#bubble4",
    {y: 55},
    {duration: 1.75},
    0.8
    )
    .fromTo(
    "#bubble5",
    {y: 55},
    {},
    1.25
    )
    .fromTo(
    "#bubble6",
    {y: 55},
    {duration: 3},
    1.4
    )
    .fromTo(
    "#bubble7",
    {x: 40, y: 55},
    {},
              
    )
    .fromTo(
    "#bubble8",
    {y: 55},
    {duration: 3},
    1
    )
    .fromTo(
    "#bubble9",
    {y: 55},
    {},
    0.5
    )
    .fromTo(
    "#bubble10",
    {x: 55, y: 55},
    {duration: 2},
    0.6
    )
    .fromTo(
    "#bubble11",
    {y: 55},
    {duration: 1.8},
    )
    .fromTo(
    "#bubble13",
    {y: 55},
    {duration: 3},
    1.3
    )
    .fromTo(
    "#bubble14",
    {x:30, y: 55},
    {},
    )
    .fromTo(
    "#bubble15",
    {x: 65, y: 55},
    {duration: 2 },
    1.3
    )
    .fromTo(
    "#bubble16",
    {y: 55},
    { },
    0.3
    )
    .fromTo(
    "#bubble17",
    {y: 55},
    { },
    1
    )
    .fromTo(
    "#bubble18",
    {y: 55},
    { duration: 2},
    0.5
    )
    .fromTo(
    "#bubble19",
    {y: 55},
    {},
    0
    )
    .fromTo(
    "#bubble20",
    {y: 55},
    {},
    0.6
    )
    .fromTo(
    "#bubble21",
    {x:70, y: 55},
    {duration: 1.5},
    1.2
    )
    .fromTo(
    "#bubble22",
    {x:-20, y: 55},
    {duration: 3},
    0.9
    )
    .fromTo(
    "#bubble23",
    {x:11, y: 55},
    {duration: 1.7},
    2.1
    )
    .fromTo(
    "#bubble24",
    {x:-100, y: 55},
    {duration: 1.7},
    2.6
    )
    .fromTo(
    "#bubble25",
    { y: 55},
    {},
    0.6
    )
    .fromTo(
    "#bubble26",
    {x:35, y: 55},
    {duration:2},
    0
    );

}

function sliderMobile(){

  const swiper = new Swiper('.swiper-container', {

    slidesPerView: 3,
    loopPreventsSlide: false,
    loop: true,
    spaceBetween: 18,
  });

}


function apparitionButtonApp(){

  var useAppCallingButton = document.querySelector(".button--useapp");

  window.addEventListener("scroll", scrollApparitionFunction);

  function scrollApparitionFunction() {
    let y = window.scrollY;
    let h = window.innerHeight;
    if (y > h) {
      gsap.to(useAppCallingButton,{
        scale:1,
        duration:0.2,
        ease: "ease-in"
      });
    }else{
      gsap.to(useAppCallingButton,{
        scale:0,
        duration:0.1,
        ease: "ease-out"
      });
    }
  }
}




var activePage = document.body.dataset.index;


if (activePage){
  animBubbles();
  sliderMobile();
  apparitionButtonApp();

}


